import { showAdminToast } from "./ShowToast";



const BILLING_PENDING_KEY = "upncomer_billing_pending";

const BILLING_COMPLETE_KEY = "upncomer_billing_complete";

const PENDING_MAX_MS = 30 * 60 * 1000;



export const BILLING_COMPLETE_EVENT = "upncomer:billing-complete";



/** Clear stuck overlays and nudge the browser to repaint after a background tab regains focus. */

export const restoreTabRendering = () => {

    document.body.classList.remove("admin-sidebar-open");

    if (document.body.style.overflow === "hidden") {

        document.body.style.overflow = "";

    }

    if (document.documentElement.style.overflow === "hidden") {

        document.documentElement.style.overflow = "";

    }

    requestAnimationFrame(() => {

        window.dispatchEvent(new Event("resize"));

        document.querySelectorAll("img").forEach((img) => {

            if (!img.currentSrc && !img.src) return;

            img.style.transform = "translateZ(0)";

            requestAnimationFrame(() => {

                img.style.transform = "";

            });

        });

    });

};



export const markBillingFlowStarted = () => {

    localStorage.setItem(

        BILLING_PENDING_KEY,

        JSON.stringify({

            sourceUrl: window.location.href,

            startedAt: Date.now(),

        })

    );

};



const getPendingFlow = () => {

    try {

        const raw = localStorage.getItem(BILLING_PENDING_KEY);

        if (!raw) return null;

        const data = JSON.parse(raw);

        if (!data?.startedAt || Date.now() - data.startedAt > PENDING_MAX_MS) {

            localStorage.removeItem(BILLING_PENDING_KEY);

            return null;

        }

        return data;

    } catch {

        localStorage.removeItem(BILLING_PENDING_KEY);

        return null;

    }

};



const isBillingReturnUrl = () => {

    const params = new URLSearchParams(window.location.search);

    const status = params.get("status");

    if (status === "success" || status === "cancel") return true;

    if (params.get("billing_return") === "1") return true;

    return Boolean(getPendingFlow());

};



const notifyOpenerTab = (payload) => {

    localStorage.setItem(BILLING_COMPLETE_KEY, JSON.stringify(payload));

};



const STRIPE_QUERY_KEYS = [

    "status",

    "billing_return",

    "payment_intent",

    "payment_intent_client_secret",

    "redirect_status",

];



const cleanBillingQueryFromUrl = () => {

    const params = new URLSearchParams(window.location.search);

    let changed = false;

    STRIPE_QUERY_KEYS.forEach((key) => {

        if (params.has(key)) {

            params.delete(key);

            changed = true;

        }

    });

    if (!changed) return;

    const next = `${window.location.pathname}${params.toString() ? `?${params}` : ""}${window.location.hash}`;

    window.history.replaceState({}, "", next);

};



/** After Stripe Payment Element redirect (e.g. 3DS) lands back on site. */

const handleStripePaymentElementReturn = (dispatch, refreshCredits) => {

    const params = new URLSearchParams(window.location.search);

    const redirectStatus = params.get("redirect_status");

    if (!params.get("payment_intent") || !redirectStatus) return false;



    if (redirectStatus === "succeeded") {

        showAdminToast("success", "Payment successful! Your credits have been added.");

        if (refreshCredits) dispatch(refreshCredits());

    } else if (redirectStatus === "failed") {

        showAdminToast("error", "Payment failed. Please try again.");

    }



    cleanBillingQueryFromUrl();

    return true;

};



/**

 * Stripe return landed in the popup tab — forward to the original tab and close this one.

 * @returns {boolean} true if this tab should stop rendering (closing)

 */

export const tryRedirectBillingReturnToOpener = () => {

    if (!isBillingReturnUrl()) return false;



    const params = new URLSearchParams(window.location.search);

    const status = params.get("status") || "portal";



    if (window.opener && !window.opener.closed) {

        try {

            if (window.opener.location.origin === window.location.origin) {

                localStorage.removeItem(BILLING_PENDING_KEY);

                notifyOpenerTab({ status, ts: Date.now() });

                window.opener.focus();

                window.close();

                return true;

            }

        } catch (err) {

            console.warn("Billing return: opener redirect failed", err);

        }

    }



    if (getPendingFlow()) {

        notifyOpenerTab({ status, ts: Date.now() });

        localStorage.removeItem(BILLING_PENDING_KEY);

        window.close();

        return true;

    }



    return false;

};



/**

 * Original tab: listen for billing completion from the Stripe popup tab.

 */

let lastBillingNotice = { status: "", at: 0 };



const applyBillingComplete = (dispatch, refreshWorkspaceSession, payload) => {

    const noticeStatus = payload?.status || "";

    const now = Date.now();

    if (noticeStatus && noticeStatus === lastBillingNotice.status && now - lastBillingNotice.at < 8000) {

        return;

    }

    lastBillingNotice = { status: noticeStatus, at: now };



    restoreTabRendering();

    const status = payload?.status;



    window.focus();



    if (

        refreshWorkspaceSession &&

        (status === "success" || status === "portal")

    ) {

        dispatch(refreshWorkspaceSession());

    }



    cleanBillingQueryFromUrl();

    localStorage.removeItem(BILLING_COMPLETE_KEY);



    const showResultToast = () => {

        if (status === "success") {

            showAdminToast("success", "Success! Your subscription has been activated.", {

                toastId: "billing-subscription-success",

            });

        } else if (status === "cancel") {

            showAdminToast("error", "Payment cancelled", {

                toastId: "billing-subscription-cancel",

            });

        }

    };



    window.setTimeout(() => {

        window.dispatchEvent(

            new CustomEvent(BILLING_COMPLETE_EVENT, { detail: payload })

        );

        window.setTimeout(showResultToast, 500);

    }, 50);

};



export const subscribeToBillingComplete = (

    dispatch,

    refreshWorkspaceSession,

    refreshCredits

) => {

    const handleComplete = (payload) =>

        applyBillingComplete(dispatch, refreshWorkspaceSession, payload);



    handleStripePaymentElementReturn(dispatch, refreshCredits);



    const params = new URLSearchParams(window.location.search);

    const status = params.get("status");

    // Popup return tab forwards to opener — only handle URL status on the main tab.

    if (

        (status === "success" || status === "cancel") &&

        (!window.opener || window.opener.closed)

    ) {

        handleComplete({ status });

    }



    const onStorage = (event) => {

        if (event.key !== BILLING_COMPLETE_KEY || !event.newValue) return;

        try {

            handleComplete(JSON.parse(event.newValue));

        } catch {

            localStorage.removeItem(BILLING_COMPLETE_KEY);

        }

    };



    const onFocus = () => {

        try {

            const raw = localStorage.getItem(BILLING_COMPLETE_KEY);

            if (!raw) return;

            handleComplete(JSON.parse(raw));

        } catch {

            localStorage.removeItem(BILLING_COMPLETE_KEY);

        }

    };



    window.addEventListener("storage", onStorage);

    window.addEventListener("focus", onFocus);

    return () => {

        window.removeEventListener("storage", onStorage);

        window.removeEventListener("focus", onFocus);

    };

};


